export const heading = {
  greeting: "Hi.",
  introduction: "I'm ",
  name: "Srikar Sunchu",
  title: "Design Engineer | Frontend Developer",
  description: [
    {
      text: "Design Engineer specializing in ",
    },
    {
      text: "React",
      type: "bold",
    },
    {
      text: ", ",
    },
    {
      text: "TypeScript",
      type: "bold",
    },
    {
      text: " and ",
    },
    {
      text: "creative animation",
      type: "bold",
    },
    {
      text:
        ". I bridge the gap between design and development, crafting beautiful, performant interfaces with a focus on ",
    },
    {
      text: "motion design",
      type: "bold",
    },
    {
      text: ", ",
    },
    {
      text: "interaction",
      type: "bold",
    },
    {
      text: " and ",
    },
    {
      text: "user experience",
      type: "bold",
    },
    {
      text:
        ". Currently leading design and development at 9M Holdings. Visit ",
    },
    {
      text: "srikarsunchu.com",
      type: "link",
      link: "https://www.srikarsunchu.com",
    },
    {
      text: " to see my work.",
    },
  ],
};
